"use client";
import "./index.es73.js";
import p, { useState as k, useId as I, useEffect as g, useMemo as f } from "react";
import w from "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import C from "./index.es421.js";
import "./index.es78.js";
import "./index.es79.js";
const q = ({
  name: b,
  values: m,
  label: d,
  options: l,
  text: r,
  onChange: u,
  ...h
}) => {
  const { minimum: i = 1, maximum: n = l.length } = h, [t, s] = k(
    new Set(m)
  ), a = I();
  g(() => {
    s(new Set(m));
  }, [m]);
  const $ = f(
    () => t.size <= i,
    [t, i]
  ), v = f(
    () => typeof n == "number" ? t.size >= n : !1,
    [t, n]
  ), c = (e) => t.has(e), x = (e) => c(e) ? $ : v, y = typeof r == "function" ? r(Array.from(t), l) : r, S = (e) => () => {
    const o = new Set(t);
    o.has(e) ? o.delete(e) : o.add(e), u ? u(Array.from(o)) : s(o);
  };
  return /* @__PURE__ */ p.createElement(
    C,
    {
      label: d,
      buttonText: y,
      buttonId: `${a}-button`,
      listboxId: `${a}-listbox`
    },
    l.map((e) => /* @__PURE__ */ p.createElement(
      w,
      {
        key: `select-choice-${a}-${e.value}`,
        inputId: `select-choice-${a}-${e.value}`,
        name: `${b}-${e.value}`,
        isChecked: c(e.value),
        isDisabled: x(e.value),
        label: e.label,
        onChange: S(e.value)
      }
    ))
  );
};
export {
  q as default
};
//# sourceMappingURL=index.es361.js.map
